<template>
  <div>

    <div>            

            <strong><label for="confirmTerms" generated="true" class="error strong smaller mbm"></label></strong>

            <div class="row">

                <div class="columns small-1">
                    <input class="man" name="confirmTerms" id="confirmTerms" type="checkbox" data-rule-required="true" data-msg-required="Please accept these Terms of Use to continue" />
                </div>
                <div class="columns small-11">
                    <label for="confirmTerms" class="smaller inline left">
                    I agree to these <a href="#" :data-reveal-id="modalName"><strong>Terms of Use</strong></a>
                    <span v-if="role != 'coach'">and provide ClassForKids with explicit consent to process any special category personal data provided by me to enable Organisers to deliver Classes.</span>
                    </label>
                </div>

            </div>
        
    </div>
    

    <div :id="modalName" class="reveal-modal" data-reveal aria-labelledby="modalTitle" aria-hidden="true" role="dialog">
        <div class="text-center">
            <img style="max-width: 200px;" src="/assets-dev/images/app/logo_new_coloured.png" alt="ClassForKids logo">
        </div>
        <ContractSummary />
        <ContractText :signup="true" />

        <a class="close-reveal-modal" @click="closeModal()" aria-label="Close">&#215;</a>
        <div class="text-center">
            <button class="info" @click="closeModal()">Close</button>
        </div>
    </div>
  </div>
</template>

<script>
import ContractSummary from '../Contract/ContractSummary';
import ContractText from '../Contract/ContractText';

export default {
    data() {
        return {
            modalName: 'contractModal'
        };
    },

    props: {
        role: {
            required: false,
            type: String
        }
    },

    methods: {
        closeModal() {
          $('#' + this.modalName).foundation('reveal', 'close');
        },
    },
    created() {
        const role = this.role || this.$root.$el.dataset.userRole;
        this.$store.dispatch('GET_CONTRACT_MARKUP', role);
        this.$store.dispatch('GET_CONTRACT_SUMMARY_MARKUP', role);
    },
    components: {
        ContractSummary,
        ContractText
    }
};
</script>

<style>
</style>
